import React, { useEffect, useState } from "react";
import ContextProvider from "./components/Store";
import "./App.scss";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import AnimateRoutes from "./components/AnimateRoutes";
import { ToastContainer } from "react-toastify";

const App = () => {
  const [dir, setDir] = useState("rtl");
  const [lang, setLang] = useState("ar");
  useEffect(() => {
    if (localStorage.getItem("dir")) {
      setDir(localStorage.getItem("dir"));
      document.body.style.direction = dir;
    } else {
      localStorage.setItem("dir", "rtl");
    }
    if (dir === "rtl") {
      setLang("ar");
    } else {
      setLang("en");
    }
  }, [dir]);
  //////////////////////////////////
  return (
    <>
      <h1>My cash</h1>
      <ContextProvider dir={dir} setDir={setDir} lang={lang}>
        <Navbar />
        <div className="layer0"></div>
        <AnimateRoutes />
        <div className="layer1"></div>
        <Footer />
        <ToastContainer />
      </ContextProvider>
    </>
  );
};

export default App;
